import { FormFieldCustomProps } from '../_props'

const FormFieldCustom = <T extends object>({ render }: FormFieldCustomProps<T>) => render()

export default FormFieldCustom
